import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { NavLink, useLocation } from "react-router-dom"
import { formatRoute } from "react-router-named-routes"
import routes from "../../routes"
import { Header as DefaultHeader } from "@swipesense/layout"
import Logo from "./logo.svg"
import "./Header.scss"

const Header = (props) => {
  const pathname = useLocation().pathname
  /* istanbul ignore next */
  useEffect(() => {
    if (window.gtag !== undefined) {
      window.gtag("set", { userId: props.userId })
      window.gtag("event", "page_view", { page_location: pathname })
    }
  }, [pathname, props.userId])

  return (
    <DefaultHeader
      logo={Logo}
      initials={props.initials}
      startElements={[
        <div key="se1" className="current-facility">
          {props.facilityName || "Contact Tracing"}
        </div>,
      ]}
      navLinks={
        props.facilityId && [
          <NavLink
            className="nav-link"
            to={formatRoute(routes.overview, { facilityId: props.facilityId })}
          >
            Overview
          </NavLink>,
          <NavLink
            className="nav-link"
            to={formatRoute(routes.openCases, { facilityId: props.facilityId })}
          >
            Open Cases
          </NavLink>,
          <NavLink
            className="nav-link"
            to={formatRoute(routes.archivedCases, {
              facilityId: props.facilityId,
            })}
          >
            Archived Cases
          </NavLink>,
        ]
      }
      userNavLinks={props.userNavLinks}
      homeLinkTag={NavLink}
      homeLink={routes.home}
    />
  )
}

Header.propTypes = {
  userId: PropTypes.string,
  facilityName: PropTypes.string,
  facilityId: PropTypes.string,
  initials: DefaultHeader.propTypes.initials,
  userNavLinks: DefaultHeader.propTypes.userNavLinks,
}

export default Header
